/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineCate.vue?vue&type=template&id=3dde16fa&scoped=true"
import script from "./popMineCate.vue?vue&type=script&lang=js"
export * from "./popMineCate.vue?vue&type=script&lang=js"
import style0 from "./popMineCate.vue?vue&type=style&index=0&id=3dde16fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde16fa",
  null
  
)

export default component.exports